<template>
  <div
    class="country-card card-condition connection-frequent-events"
    :class="{
      noteq: value === 'IP_NOT_WITH_FREQUENT_EVENTS',
      'card-condition__planLimits': hasPlanLimitsRestriction('ivtIpWithFrequentEvents'),
    }"
  >
    <ui-tooltip-icon
      v-if="hasPlanLimitsRestriction('ivtIpWithFrequentEvents')"
      class="card-condition__planLimits--tooltip"
      preset="error"
      :text="t('This option is no longer active due to the subscription change to the plan which doesn’t include this option or this add-on is switched off in your subscriptions settings.')"
    />
    <ui-icon @click="emit('close')" size="12" icon="fas fa-times" class="card-condition__close" />
    <ui-radio-group style-type="inline" v-model="value" :label="t('Suspicious Traffic (Frequent Events)')">
      <div class="d-flex align-baseline ml-16">
        <ui-radio value="IP_WITH_FREQUENT_EVENTS" :label="t('Frequent')" />
        <ui-radio class="ml-16" value="IP_NOT_WITH_FREQUENT_EVENTS" :label="t('Not Frequent')" />
      </div>
    </ui-radio-group>
  </div>
</template>

<script setup lang="ts">
import { useFlowSingleValueCondition } from './useFlowSingleValueCondition';

const props = defineProps<{
  conditions: Record<string, { predicate: string; values: string }>;
}>();

const emit = defineEmits<{
  close: [];
}>();

const { t, value, hasPlanLimitsRestriction } = useFlowSingleValueCondition(props.conditions, {
  conditionKey: 'ipWithFrequentEvents',
  defaultValue: 'IP_NOT_WITH_FREQUENT_EVENTS',
  planLimitsKey: 'ivtIpWithFrequentEvents',
});
</script>
